/**
 * Maps dashboard widget IDs to Action Centre filters for badge/footer counts.
 */
export const WIDGET_ACTION_FILTERS = {
  incidents: { module: 'Incidents' },
  jobs: {
    module: 'Recruitment',
    actionTypes: ['recruitment.interview', 'recruitment.offer'],
  },
  reference_checks: { module: 'Recruitment', actionTypes: ['recruitment.reference'] },
  quotes: { module: 'NDIS', actionTypes: ['quote.action'] },
  service_agreements: { module: 'NDIS', actionTypes: ['service_agreement'] },
  policy: { module: 'HRM', actionTypes: ['policy.review'] },
  compliance_documents: { module: 'HRM', actionTypes: ['compliance.document'] },
  invoice_followups: { module: 'Invoicing', actionTypes: ['invoice.due'] },
  leave: { module: 'HRM', actionTypes: ['leave.pending_approval'] },
  esignatures: { module: 'E-Sign', actionTypes: ['esignature'] },
};

/** Module key passed to Action Centre drawer filter */
export const WIDGET_ACTION_CENTER_MODULE = {
  incidents: 'Incidents',
  jobs: 'Recruitment',
  reference_checks: 'Recruitment',
  quotes: 'NDIS',
  service_agreements: 'NDIS',
  policy: 'HRM',
  compliance_documents: 'HRM',
  invoice_followups: 'Invoicing',
  leave: 'HRM',
  esignatures: 'E-Sign',
};

export function countWidgetActions(actions = [], widgetId) {
  const filter = WIDGET_ACTION_FILTERS[widgetId];
  if (!filter || !Array.isArray(actions)) return 0;

  return actions.filter((action) => {
    if (filter.module && action.module !== filter.module) return false;
    if (filter.actionTypes?.length && !filter.actionTypes.includes(action.action_type)) {
      return false;
    }
    return true;
  }).length;
}

export function getWidgetActionCount(actionItems, widgetId) {
  return countWidgetActions(actionItems, widgetId);
}
